import Avatar from '@component/avatar'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import { agentDetail } from '@router'
import { getColliersClassName } from '@utils'
import AgentEmailButton from '../button/email'
import OfficeLine from '../officeLine'

export default function AgentPromoted({
  data
}) {

  return (
    <div className='rounded-sm overflow-hidden'>
      <OfficeLine data={data.office} bgColor={data.bgColor}></OfficeLine>
      <div className='border border-t-0 p-16 rounded-[0_0_4px_4px]'>
        <div className='flex'>
          <Avatar src={data.icon} circle alt={data.name} width={48} height={48} defaultIcon='icon-avatar' className={getColliersClassName(data.office)}></Avatar>
          <div className='flex-1 ml-8 flex flex-col justify-evenly'>
            <div className='text-font text-sm'>{data.name}</div>
            <div className='text-neutral-5 text-xs line-clamp-1'>{data.jobTitle}</div>
          </div>
        </div>
        <div className='grid grid-cols-[1fr_auto] gap-x-10 my-12'>
          <SoldDataItem title='Average sale price' value={data.soldValue}></SoldDataItem>
          <SoldDataItem title='Sold' value={data.soldNum}></SoldDataItem>
        </div>
        <DisablePrefetchLink href={agentDetail(data)} className='button-primary-out w-full'>View profile</DisablePrefetchLink>
        <AgentEmailButton data={data} full className='mt-12'>Get an appraisal</AgentEmailButton>
      </div>
    </div>
  )
}


export function SoldDataItem({
  title,
  value
}) {
  return (
    <div className='bg-neutral-1 px-16 py-8 text-font text-sm rounded-sm'>
      <div>{title}</div>
      <div className='mt-4'>{value || '-'}</div>
    </div>
  )
}